import PropTypes from "prop-types";
import React, { useContext, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../helpers/ThemeContext";
import NotificationDropdown from "../../components/Common/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";
import { withTranslation } from "react-i18next";
import logoSm from "../../assets/images/logo-sm.png";
import logoLight from "../../assets/images/Kago-color-logo.png";
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import Tooltip from "../../utils/toolTip";

const Header = (props) => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  // ✅ Apply theme class to body when theme changes
  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark-theme");
      document.body.setAttribute("data-theme", "dark");
    } else {
      document.body.classList.remove("dark-theme");
      document.body.setAttribute("data-theme", "light");
    }
    console.log(`🌓 Theme changed to: ${theme}`);
  }, [theme]);

  // Fullscreen toggle
  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  return (
    <React.Fragment>
      {/* ✅ REMOVED inline styles that broke dark mode */}
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box text-center">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-dark" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="logo-dark" height="48" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-light" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="logo-light" height="48" />
                </span>
              </Link>
            </div>
          </div>

          <div className="d-flex align-items-center">
            {/* 🌓 Theme Toggle */}
            <div className="dropdown d-inline-block">
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
                onClick={toggleTheme}
                title={theme === "light" ? "Switch to Dark Mode" : "Switch to Light Mode"}
              >
                {theme === "light" ? (
                  <i className="ri-moon-line"></i>
                ) : (
                  <i className="ri-sun-line"></i>
                )}
              </button>
            </div>

            {/* Fullscreen */}
            <Tooltip text="Full screen">
              <div className="dropdown d-none d-lg-inline-block ms-1">
                <button
                  type="button"
                  onClick={toggleFullscreen}
                  className="btn header-item noti-icon"
                  data-toggle="fullscreen"
                  title="Fullscreen"
                >
                  <i className="ri-fullscreen-line" />
                </button>
              </div>
            </Tooltip>

            {/* 🔔 Notifications - Pass notificationCount if available */}
            <NotificationDropdown 
              notificationCount={props.notificationCount || 0}
            />

            {/* 👤 Profile */}
            <ProfileMenu props={props} />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  // ✅ Optional: notification count prop
  notificationCount: PropTypes.number,
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));